/* eslint-disable @typescript-eslint/ban-types */
interface ICallbackFunction extends Function {
  selectTimeOut?: number;
  amountOfCall?: number;
}

class Extensions {

  public executeTimeout(callBack: Function, timeout: number, scope?: unknown, ...args: unknown[]) {
    const extendedFunction = <ICallbackFunction>callBack;
    if (extendedFunction.selectTimeOut) {
      clearTimeout(extendedFunction.selectTimeOut);
    }
        extendedFunction.selectTimeOut = window.setTimeout(() => {
      callBack.apply(scope, args);
    }, timeout);
  }
}

export const extensions = new Extensions();